(function ($) {
    if ($('.parking-modal').length) {

        function getUniqueListBy(arr, key) {
            return [...new Map(arr.map(item => [item[key], item])).values()]
        }

        let parkingInitialized = false;

        $.imageMapProInitialized = function(imageMapName) {
            if (imageMapName.includes("Parking")) {
                // Build floor navigation

                const priceArray = [];

                if ($('.parking-modal .parking-map-container .imp-ui-layers-select option').length && !parkingInitialized) {
                    $('.parking-modal .parking-map-container .imp-ui-layers-select option').each(function(i, el) {
                        $('.parking-modal .parking-map-container .navigation-wrap .floors-navigation').append(`
                            <li data-floor="${$(el).val()}" class="${i === 0 ? "active" : ""}">${$(el).text()}</li>
                        `);
                    })

                    $('.parking-modal .parking-map-container .navigation-wrap .floors-navigation li').on('click', function() {
                        if (!$(this).hasClass('active')) {
                            $(this).addClass('active').siblings().removeClass('active');
                            $('.parking-modal .imp-ui-layers-select').val($(this).data('floor')).trigger('change')
                        }
                    });

                    if (!$('.parking-modal .parking-map-container .imp-ui-layers-select option').length) {
                        $('.parking-modal .parking-map-container .navigation-wrap .floors-navigation').addClass('empty')
                    }
                }

                $( ".parking-modal .imp-shape-rect" ).each(function() {
                    const element = $(this)
                    const shapeTitle = $(this).data('shape-title');
                    const shapeIndex = $(this).data('index');
                    const tooltip = $(".imp-tooltip[data-index='"+shapeIndex+"'] .squares-element");

                    $.each(parkingSpaces,function(index,parkingSpace){
                        if (parkingSpace.id === shapeTitle) {

                            priceArray.push({
                                "price": parkingSpace.price,
                                "color": parkingSpace.color
                            })

                            element.addClass(`status-${parkingSpace.status}`)

                            if (parkingSpace.status === 'available') {
                                element.css('background-color', `rgba(${parkingSpace.color.red}, ${parkingSpace.color.green}, ${parkingSpace.color.blue}, 0.08)`);
                                element.html(`<div class="circle" style="background-color: rgba(${parkingSpace.color.red}, ${parkingSpace.color.green}, ${parkingSpace.color.blue}, ${parkingSpace.color.alpha})"></div>`)
                                tooltip.html(`<h3>${parkingSpace.title}</h3><p>${parkingSpace.area}</p><p>${parkingSpace.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} €</p>`)
                            }
                        }
                    });
                });

                if (!parkingInitialized) {
                    const pricesFiltered = getUniqueListBy(priceArray, 'price').sort((a, b) => (a.price < b.price) ? 1 : -1);

                    pricesFiltered.forEach(function(priceEl, i) {
                        $('.parking-modal .pricing ul').append(`
                        <li>
                            <div class="circle" style="background-color: rgba(${priceEl.color.red}, ${priceEl.color.green}, ${priceEl.color.blue}, ${priceEl.color.alpha})"></div>
                            <span>${priceEl.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} €</span>
                        </li>
                    `)
                    });
                }

                $('.parking-modal .checkbox-input input[name="parking-map-additional-info"]').on('change', function() {
                    if ($('input[name="parking-map-additional-info"]')[0].checked) {
                        $('.parking-modal .parking-map-container .imp-shape-text').addClass('active');
                    } else {
                        $('.parking-modal .parking-map-container .imp-shape-text').removeClass('active');
                    }
                });

                parkingInitialized = true;
            }
        }

        $.imageMapProEventSwitchedFloor = function () {
            if ($('input[name="parking-map-additional-info"]')[0].checked) {
                $('.parking-modal .parking-map-container .imp-shape-text').addClass('active');
            } else {
                $('.parking-modal .parking-map-container .imp-shape-text').removeClass('active');
            }
        }

        $('.parking-modal .fullscreen-trigger').on('click', function() {
            $('.parking-modal').toggleClass('fullscreen');
        });
    }
})(jQuery);